import { useLayoutEffect } from 'react';

interface IProps {
  setComplete: (status: boolean) => void;
}
export const NoBookingYet = ({ setComplete }: IProps) => {
  useLayoutEffect(() => {
    setComplete(true);
  });

  return <></>;
};
